import { render, staticRenderFns } from "./item-migration-error-list.vue?vue&type=template&id=7ef822ac"
import script from "./item-migration-error-list.vue?vue&type=script&lang=js"
export * from "./item-migration-error-list.vue?vue&type=script&lang=js"
import style0 from "./item-migration-error-list.vue?vue&type=style&index=0&id=7ef822ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports